import React from 'react';
import { Switch } from 'react-router-dom';
import asyncComponent from 'util/asyncComponent';
import { PermissionRoute } from './common/PermissionRoute';
import { MenuPermissions } from 'ducks/auth/types';

const AdminRoutes = ({ match }) =>
  <>
    <PermissionRoute permission={MenuPermissions.SETTINGS} path={`${match.url}/settings`} exact component={(asyncComponent(() => import('../pages/admin/Settings')))}/>
    <PermissionRoute permission={MenuPermissions.ACCOUNT_INFO} path={`${match.url}/my-account`} exact component={(asyncComponent(() => import('../pages/admin/MyAccount')))}/>

    <PermissionRoute permission={MenuPermissions.SYSTEM_LOG} path={`${match.url}/system-log`} exact component={(asyncComponent(() => import('../pages/admin/SystemLog')))}/>
    <PermissionRoute permission={MenuPermissions.SYSTEM_LOG} path={`${match.url}/system-log/:id`} exact component={(asyncComponent(() => import('../pages/admin-subpages/SystemLog')))}/>

    <PermissionRoute permission={MenuPermissions.FORMS} path={`${match.url}/forms`} exact component={(asyncComponent(() => import('../pages/admin/Forms')))}/>
    <PermissionRoute permission={MenuPermissions.FORMS} path={`${match.url}/forms/:id`} exact component={(asyncComponent(() => import('../pages/admin-subpages/Forms')))}/>

    <PermissionRoute permission={MenuPermissions.BRANCHES} path={`${match.url}/branches`} exact component={(asyncComponent(() => import('../pages/admin/Branches')))}/>

    <Switch>
      <PermissionRoute permission={MenuPermissions.BRANCHES} path={`${match.url}/branches/new`} exact component={(asyncComponent(() => import('../pages/admin-subpages/branches/CreateBranch')))} />
      <PermissionRoute permission={MenuPermissions.BRANCHES} path={`${match.url}/branches/:id`} exact component={(asyncComponent(() => import('../pages/admin-subpages/branches/EditBranch')))} />
    </Switch>
  </>;

export { AdminRoutes };
